import { render, staticRenderFns } from "./DocumentCardComponents.vue?vue&type=template&id=54c982b9&scoped=true&"
import script from "./DocumentCardComponents.vue?vue&type=script&lang=js&"
export * from "./DocumentCardComponents.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCardComponents.vue?vue&type=style&index=0&id=54c982b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c982b9",
  null
  
)

export default component.exports